<template>
    <div class="tpl-group-uploader">
        <template v-if="multi">
            <el-dropdown @command="onCommandForFreeVal">
                <el-button :type="type === multiType ? 'primary': 'default'" round class="tpl-upload-btn">
                    {{btnName}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="false">上传固定模板</el-dropdown-item>
                    <el-dropdown-item :command="true">上传自由模板</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <psd-parse class="tpl-upload-hide" @onCompleted="onParsingCompleted" @onFileChange="init" :type="type" :isFree="isFree">
                <el-button class="tpl-upload-btn" ref="uploadBtn" :type="type === multiType ? 'primary': 'default'" round>{{btnName}}</el-button>
            </psd-parse>
        </template>
         <template v-else>
             <psd-parse @onCompleted="onParsingCompleted"
                        @onFileChange="init"
                        :type="type" :isFree="freeTplUploaderVisible && !fixTplUploaderVisible">
                 <el-button class="tpl-upload-btn"  ref="uploadBtn" :type="type === multiType ? 'primary': 'default'" round>{{btnName}}</el-button>
             </psd-parse>
         </template>
        <attr-dialog
            v-model="attrDialogVisible"
            :data="newTemplate"
            :isNew="true"
            @onSave="onCompleted"
            :show="attrDialogVisible"></attr-dialog>
        <el-dialog
            title=""
            class="loading-dialog"
            append-to-body
            width="650px"
            :modal="false"
            :show-close="false"
            :visible="parseLoading">
            <section class="loading-dialog-body">
                <div class="el-loading-spinner"><i class="el-icon-loading"></i><p class="el-loading-text">模板解析中...</p></div>
            </section>
        </el-dialog>
    </div>
</template>
<script>
    import templateService from '@/request/service/template-service';
    import uploadService from '@/request/service/fileupload-service';
    import attrDialog from '../../components/attr-dialog/attr-dialog';
    import {psd_parse_url, empty_template,template_type_single, template_type_multiple, template_type_ppt} from '@/const.js';
    import groupService from '../../../request/service/group-service'
    import psdParse from './psd-parseing-index'
    // import psdParse from '@/components/app-layout/header/psd-parse/index.vue'
    export default {
        components: {attrDialog, psdParse},
        props:{
            type: {
                type: String, default: template_type_multiple,
            },
            projectId: String,
            multi: Boolean,
            btnName: {
                type: String, default: '上传图文模板'
            },
        },
        data() {
            return {
                loadingObj: null,
                saveLoading: false,
                uploadUrl: psd_parse_url,
                multiType: template_type_multiple,
                singleType: template_type_single,
                pptType: template_type_ppt,
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                parseImgSrc: '',
                template: JSON.parse(JSON.stringify(empty_template)),
                allowCreate: false,
                attrDialogVisible: false,
                groupMaterialList: [],
                newTemplate:JSON.parse(JSON.stringify(empty_template)),
                cacheData:{tagNames: null, group: ''},
                isFree: false,
                parseLoading: false
            }
        },
        computed: {
            freeTplUploaderVisible(){
                return this.$store.getters['app/freeTplUploaderVisible'];
            },
            fixTplUploaderVisible(){
                return this.$store.getters['app/fixTplUploaderVisible'];
            },
        },
        created(){
        },
        methods: {
            init() {
                this.loading(true);
            },
            onParsingCompleted(psdData){
                this.template = JSON.parse(JSON.stringify(psdData));
                this.saveTemplate();
            },
            loading(trueOrFalse) {
                this.parseLoading = trueOrFalse;
                // if (trueOrFalse) {
                //     this.loadingObj = this.$loading({
                //         lock: true,
                //         customClass:'template-parse-loading',
                //         text: '模板解析中...',
                //         spinner: 'el-icon-loading',
                //         background: 'rgba(255,255,255, 0.8)'
                //     });
                // } else {
                //     this.loadingObj.close();
                // }
            },
            getPsdImgUrl(fileStr) {
                return uploadService.uploadFileByBase64(fileStr);
            },
            saveTemplate() {
              this.getPsdImgUrl(this.template.defaultUrl).then((urlData) => {
                let data = this.template;
                data.defaultUrl = urlData.url;
                if (data.name.length > 20) {
                  data.name = data.name.substring(0, 20);
                }
                this.save(data);
              }, (error) => {
                this.$message.success(error);
                  this.saveLoading = false;
              });
            },
            async save(data) {
                data.type = this.type;
                let cloneData = JSON.parse(JSON.stringify(data));
                cloneData.projectId = this.projectId;
                let templateId = await templateService.saveTemplate(cloneData).finally(() => {this.saveLoading = false;});
                if(!templateId){
                    this.saveLoading = false;
                    return;
                }
                if(this.groupMaterialList && this.groupMaterialList.length > 0){
                    await this.saveGroup(this.projectId, templateId, this.groupMaterialList).finally(() => {this.saveLoading = false;})
                }
                this.$store.dispatch('app/queryTemplateTagList', this.projectId);
                this.getTemplateById(templateId).then(() => {
                  this.attrDialogVisible = true;
                  this.loading(false);
                  this.$emit('success');
                }).catch(() => {
                });
                this.$store.commit('templateGroup/set_left_active_name', ['1','2', '3']);
            },
            onCompleted(){
                this.attrDialogVisible = false;
                this.$emit('success');
            },
            onCancel() {
            },
            saveGroup(projectId, templateId, groupMaterialList){
                return groupService.addGroup(groupMaterialList, projectId, templateId);
            },
            onUploadGroup(groupMaterialList){
                this.groupMaterialList = this.groupMaterialList.concat(groupMaterialList);
            },
            onDelMaterialGroup(index){
                this.groupMaterialList.splice(index ,1);
            },
            getTemplateById(id) {
               return templateService.getTemplateById(id).then((data) => {
                    if(data.tags){
                        data.tagNames = data.tags.map((item) => {
                            return item.name;
                        });
                    }
                 if(data.tplGroupName.indexOf('DEFAULT_') > -1 ){
                   data.tplGroupName = '';
                 }
                 this.newTemplate = data;
                });
            },
            onCommandForFreeVal(isFree){
                this.isFree = isFree;
                this.$refs.uploadBtn.$el.click()
            }
        }
    }
</script>
<style lang="scss">
    @import "tpl-group-uploader";
</style>